"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _nuiIntl = require("@concur/nui-intl");

var _reactRedux = require("react-redux");

var actions = _interopRequireWildcard(require("./listingModule"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoConnectInput = function AutoConnectInput(_ref) {
  var listing = _ref.listing,
      isDisabled = _ref.isDisabled,
      updateLoyaltyNum = _ref.updateLoyaltyNum,
      formatter = _ref.formatter;
  var loyaltyNumber = listing.loyaltyNumber,
      ID = listing.ID;

  var handleFormUpdate = function handleFormUpdate(e) {
    updateLoyaltyNum(ID, e.target.value);
    updateLoyaltyNum(listing.core.v1ID, e.target.value);
  };

  var htmlMarkup = function htmlMarkup(html) {
    return {
      __html: html
    };
  };

  var renderLoyaltyInput = function renderLoyaltyInput() {
    if (!listing.core.triplinkLoyaltyNumber) {
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("input", {
        style: {
          width: '100%'
        },
        type: "text",
        name: "loyaltyNumber",
        className: "form-control",
        disabled: isDisabled,
        "aria-label": formatter.formattedMessage({
          id: 'LoyaltyNumber1',
          values: {
            number: ''
          }
        }),
        placeholder: formatter.formattedMessage({
          id: 'LoyaltyNumber1',
          values: {
            number: ''
          }
        }),
        value: loyaltyNumber,
        onChange: handleFormUpdate
      }));
    }

    if (!listing.core.isConnectionPending) {
      return _react.default.createElement("div", null, _react.default.createElement("h4", {
        dangerouslySetInnerHTML: htmlMarkup(formatter.formattedMessage({
          id: 'ExistingLoyaltyNum'
        }))
      }));
    }
  };

  return _react.default.createElement("div", null, _react.default.createElement("h3", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Connect"
  })), _react.default.createElement("br", null), !listing.core.triplinkLoyaltyNumber && _react.default.createElement("div", null, _react.default.createElement("h4", null, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "AddLoyaltyNumber"
  })), _react.default.createElement("br", null)), renderLoyaltyInput());
};

AutoConnectInput.propTypes = {
  listing: _propTypes.default.shape({
    loyaltyNumber: _propTypes.default.string
  }),
  updateLoyaltyNum: _propTypes.default.func.isRequired,
  formatter: _propTypes.default.object
};

var _default = (0, _reactRedux.connect)(null, {
  updateLoyaltyNum: actions.updateLoyaltyNum
})((0, _nuiIntl.withFormatter)(AutoConnectInput));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/AutoConnectInput.js
// module id = 262
// module chunks = 0